import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2'

@Injectable({
  providedIn: 'root'
})
export class ModelService {
  constructor
  (
    private router:Router
  )
  {

  }

  showSuccessAlert(message: string) {
    Swal.fire({
      html: `<i class="bi bi-check-circle-fill" style="font-size: 2rem !important; color: green !important;"></i> <br>
      <small class="small-text">${message}</small>`,
      icon: undefined, // Disable the default icon
      confirmButtonText: "OK",
      customClass: {
        popup: 'swal2-popup',
        confirmButton: 'swal2-custom-button'
      },
      width: '300px'
    });
  }

  showErrorAlert(message: string) {
    Swal.fire({

      html: `<i class="bi bi-x-circle-fill" style="font-size: 2rem; color: red !important;"></i>
              <br>
              <small class="small-text">${message}</small>
            `,
      icon: undefined,
      confirmButtonText: "OK",
      customClass: {
        popup: 'swal2-popup',
        confirmButton: 'swal2-custom-button'
      },
      width: '300px'
    });
  }

  showWarningAlert(message: string) {
    Swal.fire({
      html: `<i class="bi bi-exclamation-triangle-fill" style="font-size: 2rem; color: orange;"></i> <br>
      <small class="small-text">${message}</small>`,
      icon: undefined, // Disable the default icon
      confirmButtonText: "OK",
      customClass: {
        popup: 'swal2-popup',
        confirmButton: 'swal2-custom-button'
      },
      width: '300px'
    });
  }

  showInfoAlert(message: string) {
    Swal.fire({
      html: `<img src="${message}" alt="Icon" style="height:40px" /> <br> <br>
      <small class="small-text">
       Vous êtes ici.
      </small>`,
      icon: undefined, // Disable the default icon
      confirmButtonText: "OK",
      customClass: {
        popup: 'swal2-popup',
        confirmButton: 'swal2-custom-button'
      },
      width: '300px'
    });
  }
  showInDestination(message: string) {
    Swal.fire({
      html: `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" class="bi bi-geo-fill" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M4 4a4 4 0 1 1 4.5 3.969V13.5a.5.5 0 0 1-1 0V7.97A4 4 0 0 1 4 3.999zm2.493 8.574a.5.5 0 0 1-.411.575c-.712.118-1.28.295-1.655.493a1.3 1.3 0 0 0-.37.265.3.3 0 0 0-.057.09V14l.002.008.016.033a.6.6 0 0 0 .145.15c.165.13.435.27.813.395.751.25 1.82.414 3.024.414s2.273-.163 3.024-.414c.378-.126.648-.265.813-.395a.6.6 0 0 0 .146-.15l.015-.033L12 14v-.004a.3.3 0 0 0-.057-.09 1.3 1.3 0 0 0-.37-.264c-.376-.198-.943-.375-1.655-.493a.5.5 0 1 1 .164-.986c.77.127 1.452.328 1.957.594C12.5 13 13 13.4 13 14c0 .426-.26.752-.544.977-.29.228-.68.413-1.116.558-.878.293-2.059.465-3.34.465s-2.462-.172-3.34-.465c-.436-.145-.826-.33-1.116-.558C3.26 14.752 3 14.426 3 14c0-.599.5-1 .961-1.243.505-.266 1.187-.467 1.957-.594a.5.5 0 0 1 .575.411"/>
</svg> <br> <br>
      <small class="small-text">
       Your Destination.
      </small>`,
      icon: undefined, // Disable the default icon
      confirmButtonText: "OK",
      customClass: {
        popup: 'swal2-popup',
        confirmButton: 'swal2-custom-button'
      },
      width: '300px'
    });
  }



}
